import React, { useState, useRef, useEffect } from 'react';
import '../product/ImageGallery.css';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";


const ImageGallery = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isZoomed, setIsZoomed] = useState(false);
    const [zoomStyle, setZoomStyle] = useState({});
    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [showButtons, setShowButtons] = useState(false);
    const mainImageRef = useRef(null);
    const thumbnailContainerRef = useRef(null);
    const thumbnailRefs = useRef([]);

    const baseUrl = 'https://panel.bikuyum.com/upload/';

    const fullImageUrl = images[currentIndex].startsWith('https')
        ? images[currentIndex]
        : `${baseUrl}${images[currentIndex]}?size=full`;

    useEffect(() => {
        // Resim boyutlarını ayarla
        const img = new Image();
        img.src = fullImageUrl;
        img.onload = () => {
            setImageDimensions({
                width: img.width,
                height: img.height
            });
        };
    }, [currentIndex, fullImageUrl]);

    useEffect(() => {
        // Aktif thumbnail'a scroll yap
        if (thumbnailContainerRef.current && thumbnailRefs.current[currentIndex]) {
            const container = thumbnailContainerRef.current;
            const thumbnail = thumbnailRefs.current[currentIndex];

            const scrollLeft = thumbnail.offsetLeft - container.offsetWidth / 2 + thumbnail.offsetWidth / 2;

            container.scrollTo({
                left: scrollLeft,
                behavior: 'smooth'
            });
        }

        // Thumbnail referanslarını temizle ve yeniden oluştur
        thumbnailRefs.current = thumbnailRefs.current.slice(0, images.length);
    }, [currentIndex, images.length]);

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    };

    const handleMouseMove = (e) => {
        if (!mainImageRef.current || imageDimensions.width === 0 || imageDimensions.height === 0) return;

        const { left, top, width, height } = mainImageRef.current.getBoundingClientRect();
        const offsetX = e.clientX - left;
        const offsetY = e.clientY - top;
        const zoomAreaSize = 400;

        // Fare imlecinin resim üzerindeki yüzdesel konumunu hesapla
        const xPercent = (offsetX / width) * 100;
        const yPercent = (offsetY / height) * 100;

        // Büyütme faktörünü ayarla
        const zoomFactor = 2;

        // Büyütülmüş resmi ana resmin sağında sabit konumda göster
        const rightPosition = left + width + 20; // Ana resmin sağından 20px boşluk
        const topPosition = top; // Ana resimle aynı hizaya

        setZoomStyle({
            backgroundImage: `url(${fullImageUrl})`,
            backgroundSize: `${width * zoomFactor}px ${height * zoomFactor}px`,
            backgroundPosition: `${xPercent}% ${yPercent}%`,
            width: `${zoomAreaSize}px`,
            height: `${zoomAreaSize}px`,
            position: 'fixed',
            left: `${rightPosition}px`,
            top: `${topPosition}px`,
            border: '1px solid #ccc',
            zIndex: 1000,
            borderRadius: '5px',
            pointerEvents: 'none',
            transform: 'none',
            backgroundRepeat: 'no-repeat'
        });
    };

    return (
        <div
            className="image-gallery"
            onMouseEnter={() => setShowButtons(true)}
            onMouseLeave={() => setShowButtons(false)}
        >
            <div
                className="main-image position-relative"
                ref={mainImageRef}
                onMouseEnter={() => setIsZoomed(true)}
                onMouseLeave={() => setIsZoomed(false)}
                onMouseMove={handleMouseMove}
            >
                <img src={fullImageUrl}
                    alt={`Product image ${currentIndex + 1}`}
                    onError={(e) => {
                        e.target.src = '/no-image.png';
                    }} />
                {images.length > 1 && (
                    <>
                        <button className="carousel-button prev" onClick={handlePrev}>
                            <IoIosArrowBack />
                        </button>
                        <button className="carousel-button next" onClick={handleNext}>
                            <IoIosArrowForward />
                        </button>
                    </>
                )}
            </div>
            {isZoomed && (
                <div className="zoomed-image" style={zoomStyle} />
            )}
            <div className="thumbnail-container" ref={thumbnailContainerRef}>
                {images.length > 0 && images.map((image, index) => {
                    const imageUrl = image.startsWith('https')
                        ? image
                        : `${baseUrl}${image}`;

                    return (
                        <img
                            key={index}
                            ref={el => thumbnailRefs.current[index] = el}
                            src={imageUrl}
                            alt={`Thumbnail ${index + 1}`}
                            className={`thumbnail ${index === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(index)}
                            onError={(e) => {
                                e.target.src = '/no-image.png';
                            }}
                        />
                    );
                })}
            </div>

        </div>
    );
};

export default ImageGallery;